import {useEffect} from 'react';

const useMenuScrollContainment = (navigationNode, enabled) => {
    useEffect(() => {
        if (!enabled || !navigationNode) return undefined;

        const drawer = navigationNode.closest('.ant-drawer');

        if (!drawer) return undefined;

        let lastTouch = null;

        const canScroll = (target, deltaY, deltaX) => {
            const horizontal = Math.abs(deltaX) > Math.abs(deltaY);
            const delta = horizontal ? deltaX : deltaY;

            if (delta === 0) return false;

            let element = target instanceof Element ? target : target.parentElement;

            while (element && element !== drawer) {
                const style = window.getComputedStyle(element);
                const overflow = horizontal ? style.overflowX : style.overflowY;
                const position = horizontal ? element.scrollLeft : element.scrollTop;
                const maximum = horizontal
                    ? element.scrollWidth - element.clientWidth
                    : element.scrollHeight - element.clientHeight;

                if (/auto|scroll|overlay/.test(overflow) && maximum > 0) {
                    if (delta < 0 ? position > 0 : position < maximum - 1) return true;
                }
                element = element.parentElement;
            }

            return false;
        };

        const containGesture = (event, deltaY, deltaX) => {
            // Prevent page/map listeners from receiving gestures over the navigation.
            event.stopPropagation();
            if (!canScroll(event.target, deltaY, deltaX) && event.cancelable) event.preventDefault();
        };

        const handleTouchStart = (event) => {
            const touch = event.touches.length === 1 ? event.touches[0] : null;

            lastTouch = touch
                ? {startX: touch.clientX, startY: touch.clientY, x: touch.clientX, y: touch.clientY, dragging: false}
                : null;
        };

        const handleTouchMove = (event) => {
            if (lastTouch === null || event.touches.length !== 1) return;

            const nextTouch = event.touches[0];
            const deltaY = lastTouch.y - nextTouch.clientY;
            const deltaX = lastTouch.x - nextTouch.clientX;

            // Small finger movements should still behave as taps on links/buttons.
            if (
                !lastTouch.dragging &&
                Math.max(
                    Math.abs(nextTouch.clientY - lastTouch.startY),
                    Math.abs(nextTouch.clientX - lastTouch.startX)
                ) < 8
            )
                return;

            lastTouch.dragging = true;
            lastTouch.x = nextTouch.clientX;
            lastTouch.y = nextTouch.clientY;
            containGesture(event, deltaY, deltaX);
        };

        const handleTouchEnd = () => {
            lastTouch = null;
        };
        const handleWheel = (event) => containGesture(event, event.deltaY, event.deltaX);

        drawer.addEventListener('touchstart', handleTouchStart, {passive: true});
        drawer.addEventListener('touchmove', handleTouchMove, {passive: false});
        drawer.addEventListener('touchend', handleTouchEnd);
        drawer.addEventListener('touchcancel', handleTouchEnd);
        drawer.addEventListener('wheel', handleWheel, {passive: false});

        return () => {
            drawer.removeEventListener('touchstart', handleTouchStart);
            drawer.removeEventListener('touchmove', handleTouchMove);
            drawer.removeEventListener('touchend', handleTouchEnd);
            drawer.removeEventListener('touchcancel', handleTouchEnd);
            drawer.removeEventListener('wheel', handleWheel);
        };
    }, [enabled, navigationNode]);
};

export default useMenuScrollContainment;
